import { BsUtil } from "../util";
import { Retriever } from "../retriever";
import { BFFGateway } from "../dependencies";
import { Parser } from "../parser";
import { LibConfig, setLibConfig } from "../config";
/**
 * Initialize BsUtil configuration. Create new instance or return already created one
 * @param {BsUtilInitConfig} config Initial configuration to be set
 * @return {BsUtil} Newly created or already existing  instance
 */
export var init = function (config) {
    if (Object.isFrozen(LibConfig)) {
        // Throw error ?
        return BsUtil.getInstance();
    }
    setLibConfig(config);
    Object.freeze(LibConfig);
    return new BsUtil(new Retriever(new BFFGateway()), new Parser());
};
/**
 * Get BsUtil instance
 * @return {BsUtil} The existing instance
 */
export var getInstance = function () {
    return BsUtil.getInstance();
};
//# sourceMappingURL=init.js.map